import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import Link from "next/link";
import styles from "./styles.module.scss";
import Mail from "/public/site-assets/svg/mail.svg";
import LinkedIn from "/public/site-assets/svg/linkedin.svg";

export default function BlogAuthor({
  author,
  consultant,
  customClass = "",
  showPosition = true,
  showEmail = true,
  showLinkedin = true,
}) {
  // News passes the author as free text, campaign blogs as a Consultants category link
  const authorName =
    typeof author === "string" ? author : author?.name?.en ?? author?.name ?? "";
  // A category link stores a consultant id, so never fall back to printing the raw
  // value — same for an unresolved page builder placeholder, e.g. "{{Author}}"
  const isReference =
    /^{{.*}}$/.test(authorName.trim()) ||
    /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(authorName.trim());
  const name = consultant?.name || (isReference ? "" : authorName);

  if (!name) {
    return null;
  }

  const email = showEmail ? consultant?.email : "";
  const linkedin = showLinkedin ? consultant?.linkedin : "";

  return (
    <div
      className={`${styles.root} blog-author d-inline-flex align-items-center position-relative ${
        consultant?.image ? "" : "no-avatar"
      } ${customClass}`}
    >
      {consultant?.image ? (
        <SourceFlowImage
          src={consultant.image}
          size="800x800"
          alt={name}
          className="consultant rounded-circle"
          width="100%"
          height="100%"
        />
      ) : (
        ""
      )}
      <div className="author-details d-flex flex-wrap align-items-center">
        <div className="author-meta">
          <p className="author-name m-0">
            <span className="by">by</span>
            <span>{name}</span>
          </p>
          {showPosition && consultant?.position ? (
            <div className="author-position">{consultant.position}</div>
          ) : (
            ""
          )}
        </div>
        {email || linkedin ? (
          <div className="author-contact d-flex align-items-center">
            {email ? (
              <Link href={`mailto:${email}`}>
                <a
                  className="contact-icon d-inline-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                  aria-label={`Email ${name}`}
                >
                  <Mail />
                </a>
              </Link>
            ) : (
              ""
            )}
            {linkedin ? (
              <Link href={linkedin}>
                <a
                  className="contact-icon d-inline-flex align-items-center justify-content-center rounded-circle text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${name} on LinkedIn`}
                >
                  <LinkedIn />
                </a>
              </Link>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
